// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "form input[data-v-0806fb92]{width:400px}.title-image[data-v-0806fb92]{width:300px;margin-top:10%}.Loginwindow[data-v-0806fb92]{background-image:url(/bg7.jpg);height:100vh}@media screen and (max-width:768px){.loginttl[data-v-0806fb92]{font-size:1.5rem}.modal-content[data-v-0806fb92]{margin-left:0}}", ""]);
// Exports
module.exports = exports;
